module.exports = __webpack_public_path__ + "static/media/1.cb753243.png";